import React from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import App from './App'
import { PropertiesProvider } from './context/PropertiesContext'
import { BrowserRouter } from 'react-router-dom'

const rootElement = document.getElementById('root')

const app = (
    // <React.StrictMode>
    <BrowserRouter
        future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
        }}
    >
        <PropertiesProvider>
            <App />
        </PropertiesProvider>
    </BrowserRouter>
    // </React.StrictMode>
)

if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app)
} else {
    createRoot(rootElement).render(app)
}
